export const DEFAULT_OCCUPATION_CATEGORY = "Professional Services";
